import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopupService } from '../../../services/popup.service';
import { ICONS } from '../../../constants/constants';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss'],
})
export class DeletePopupComponent {
  @Input() mainText: string;
  @Input() helperText: string = '';
  @Output() delete = new EventEmitter();

  constructor(private popupService: PopupService) {}

  close(): void {
    this.popupService.closePopup();
  }

  confirm(): void {
    this.delete.emit(this.popupService.payload);
    this.close();
  }

  protected readonly ICONS = ICONS;
}
